import { gql, useQuery } from '@apollo/client';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { myPerms } from 'src/dynamoQueries/perms';

export function useMyPerms() {
  const query = jsonToGraphQLQuery(myPerms(true));
  return useQuery(gql(query));
}
